// import React, { useEffect, useState } from "react";
// import Box from "@mui/material/Box";
// import IconButton from "@mui/material/IconButton";
// import Collapse from "@mui/material/Collapse";
// import CloseIcon from "@mui/icons-material/Close";
// import Button from "@mui/material/Button";
// import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";
// import Slide from "@mui/material/Slide";

// const Alert = React.forwardRef(function Alert(props, ref) {
// 	return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
// });
// const MessageBar = (props) => {
// 	const message = props.message;
// 	const [open, setOpen] = useState(false);
// 	const handleClick = () => {
// 		setOpen(true);
// 	};

// 	const handleClose = (event, reason) => {
// 		if (reason === "clickaway") {
// 			return;
// 		}

// 		setOpen(false);
// 	};
// 	useEffect(() => {
// 		setOpen(message ? true : false);
// 	}, [message]);
// 	return (
// 		<Snackbar
// 			open={true}
// 			autoHideDuration={6000}
// 			onClose={handleClose}
// 			anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// 			key={props.key}
// 		>
// 			<Alert
// 				onClose={handleClose}
// 				severity={props.snackMode}
// 				sx={{ width: "100%" }}
// 			>
// 				{props.message}
// 			</Alert>
// 		</Snackbar>
// 	);
// };

// export default MessageBar;

// import react, { useEffect, useState } from "react";
// import Button from "@mui/material/Button";
// import { SnackbarProvider, useSnackbar } from "notistack";

// // wrap your app
// <SnackbarProvider>
//   <App />
//   <MyButton />
// </SnackbarProvider>

// const MyButton = () => {
//   const { enqueueSnackbar, closeSnackbar } = useSnackbar()
//   return (
//     <Button onClick={() => enqueueSnackbar('I love hooks')}>
//       Show snackbar
//     </Button>
//   )
// }
